<template>
    <div class="mian">
        <div class="header" :class="home ? 'index' : ''">
            <div class="pc">
                <div class="content">
                    <div class="logo">
                        <template v-if="home">
                            <img src="../assets/logo1.png" />
                        </template>
                        <template v-else>
                            <img src="../assets/logo.png" />
                        </template>
                    </div>
                    <div class="nav">
                        <div :class="current == '/' ? 'on' : ''">
                            <router-link tag="p" to="/">首页</router-link>
                        </div>
                        <div :class="current == 'solution?index=1' ? 'on' : ''">
                            <router-link tag="p" to="/solution?index=1">解决方案</router-link>
                            <ul>
                                <router-link tag="li" to="/solution?index=1">多式联运项目开发及运营</router-link>
                                <router-link tag="li" to="/solution?index=2">自备车（箱）资产运营</router-link>
                                <router-link tag="li" to="/solution?index=3">业财务结算统计自动化</router-link>
                                <router-link tag="li" to="/solution?index=4">场站及园区运营智能化</router-link>
                                <router-link tag="li" to="/solution?index=5">平台应用开放API服务</router-link>
                            </ul>
                        </div>
                        <div :class="current == 'knowus' ? 'on' : ''">
                            <router-link tag="p" to="/knowus">了解我们</router-link>
                        </div>
                    </div>
                    <div class="login">
                        <a href="https://saas.56links.com/user/login">联运通</a>
                        <a @click="$refs.trialModal.show()">预约试用</a>
                        <template v-if="$route.query.ai">
                            <router-link tag="a" to="/ai">AI查运费</router-link>
                        </template>
                    </div>
                </div>
            </div>
            <div class="mobile">
                <div class="content">
                    <div class="logo ">
                        <img src="../assets/logo.png" />
                    </div>
                    <template v-if="drawer">
                        <div class="nav">
                            <div :class="current == '/' ? 'on' : ''">
                                <router-link tag="p" to="/">首页</router-link>
                            </div>
                            <div :class="current == 'solution?index=1' ? 'on' : ''">
                                <router-link tag="p" to="/solution?index=1">解决方案</router-link>
                                <ul @click="drawer = false">
                                    <router-link tag="li" to="/solution?index=1">多式联运项目开发及运营</router-link>
                                    <router-link tag="li" to="/solution?index=2">自备车（箱）资产运营</router-link>
                                    <router-link tag="li" to="/solution?index=3">业财务结算统计自动化</router-link>
                                    <router-link tag="li" to="/solution?index=4">场站及园区运营智能化</router-link>
                                    <router-link tag="li" to="/solution?index=5">平台应用开放API服务</router-link>
                                </ul>
                            </div>
                            <div :class="current == 'knowus' ? 'on' : ''">
                                <router-link tag="p" to="/knowus">了解我们</router-link>
                            </div>
                            <template v-if="$route.query.ai">
                                <div>
                                    <router-link tag="p" to="/ai">AI查运费</router-link>
                                </div>
                            </template>
                        </div>
                    </template>
                    <div class="btn" @click="drawer = !drawer">
                        <img src="../assets/mobile/icon-nav.png" />
                    </div>
                </div>
            </div>
        </div>
        <trialModal ref="trialModal"></trialModal>
    </div>
</template>

<script>
import trialModal from "./trialModal"
export default {
    name: "headerBar",
    props: ["current", "home"],
    components: { trialModal },
    data() {
        return {
            drawer: false
        }
    },
}
</script>

<style scoped>
@media screen and (min-width: 1025px) {
    .mobile {
        display: none;
    }

    .header {
        width: 100%;
        background: #fff;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99;
    }

    .header .content {
        width: 13rem;
        margin: 0 auto;
        display: flex;
        align-items: center;
    }

    .header .content .logo img {
        width: 1.18rem;
    }

    .header .content .nav {
        display: flex;
        align-items: center;
        padding: 0 0.3rem;
    }

    .header .content .nav div {
        height: 0.7rem;
        padding: 0 0.3rem;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .header .content .nav div:hover ul {
        display: block;
    }

    .header .content .nav div p {
        padding: 0 0.1rem;
        color: #091c2e;
        font-size: 0.16rem;
        cursor: pointer;
    }

    .header .content .nav div.on p {
        color: #1070ff;
        position: relative;
    }

    .header .content .nav div.on p::after {
        content: "";
        width: 100%;
        height: 0.03rem;
        background: #1070ff;
        position: absolute;
        left: 0;
        bottom: -0.06rem;
    }

    .header .content .nav div ul {
        width: 1.8rem;
        padding: 0.1rem 0;
        border-radius: 0.04rem;
        background: #fff;
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -0.9rem;
        display: none;
        cursor: pointer;
    }

    .header .content .nav div ul::after {
        content: "";
        border: 0.1rem solid transparent;
        border-bottom-color: #fff;
        position: absolute;
        top: -0.2rem;
        left: 50%;
        margin-left: -0.05rem;
    }

    .header .content .nav div ul li {
        font-size: 0.14rem;
        text-align: center;
        line-height: 0.3rem;
        color: #333;
    }

    .header .content .nav div ul li:hover {
        color: #0f70ff;
    }

    .header .content .login {
        margin-left: auto;
        display: flex;
        align-items: center;
    }

    .header .content .login a {
        line-height: 0.36rem;
        color: #091c2e;
        font-size: 0.14rem;
        text-align: center;
        cursor: pointer;
    }

    .header .content .login a+a {
        background: #0f70ff;
        color: #fff;
        cursor: pointer;
        margin-left: .1rem;
        padding: 0 .2rem;
    }

    .header.index {
        background-image: linear-gradient(to left, #385888 60%, #a85d69);
    }

    .header.index .content .nav div p {
        color: #fff;
    }

    .header.index .content .nav div.on p {
        color: #1070ff;
    }

    .header.index .content .login a {
        color: #fff;
    }
}

@media screen and (max-width: 1024px) {
    .pc {
        display: none;
    }

    .header {
        width: 100%;
        background: #fff;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 9999;
    }

    .header .content {
        height: 1rem;
        padding: 0 0.3rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .header .content .logo img {
        width: 2rem;
        display: block;
    }

    .header .content .nav {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 1rem;
        left: 0;
        background: rgba(0, 0, 0, 0.2);
    }

    .header .content .nav div {
        padding: 0 0.2rem;
        background: #fff;
    }

    .header .content .nav div p {
        font-size: 0.26rem;
        line-height: 1rem;
        color: #303133;
        cursor: pointer;
    }

    .header .content .nav div.on p {
        color: #0f70ff;
    }

    .header .content .nav div ul {
        padding: 0 0.2rem;
    }

    .header .content .nav div ul li {
        font-size: 0.26rem;
        line-height: 1rem;
        cursor: pointer;
        color: #303133;
    }

    .header .content .btn img {
        width: 0.32rem;
        display: block;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/headerBar.vue